import React, { useEffect } from "react";
import Layout from "../utils/core/Layout";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { forgetPasswordAction } from "../.././redux/actions/authentication/authenticationAction";
import { connect } from "react-redux";

export const ForgetPassword = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const onSubmit = (data, event) => {
    event.preventDefault();
    if (Object.keys(errors).length === 0) {
      props.forgePassword(data, navigate);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("access_token") && props.is_user === true) {
      navigate("/user/dashboard");
    }
  }, [props, navigate]);

  return (
    <div className="login-page">
      <Layout>
        <main>
          <section className="login-area">
            <div className="container">
              <div className="row">
                <div className="col-md-6 mini-7">
                  <div className="inner-content features-list-block">
                    <h2>
                      Welcome to <br></br>a new era
                    </h2>
                    <p>
                      Intro to the log in / sign up if required. Intro to the
                      log in / sign up if required. Intro to the log in / sign
                      up if required.{" "}
                    </p>
                    <ul className="features-list">
                      <li className="text-center">
                        <div className="img-wrap text-center">
                          <img
                            src="/assets/images/icons/profile.svg"
                            alt="neet"
                          />
                        </div>
                        <div className="feature-name">
                          MY <strong>PROFILE</strong>
                        </div>
                      </li>
                      <li className="text-center">
                        <div className="img-wrap text-center">
                          <img
                            src="/assets/images/icons/analytics.svg"
                            alt="neet"
                          />
                        </div>
                        <div className="feature-name">
                          MY <strong>ANALYTICS</strong>
                        </div>
                      </li>
                      <li className="text-center">
                        <div className="img-wrap text-center">
                          <img
                            src="/assets/images/icons/network.svg"
                            alt="neet"
                          />
                        </div>
                        <div className="feature-name">
                          MY <strong>NETWORK</strong>
                        </div>
                      </li>
                      <li className="text-center">
                        <div className="img-wrap text-center">
                          <img
                            src="/assets/images/icons/performance.svg"
                            alt="neet"
                          />
                        </div>
                        <div className="feature-name">
                          MY <strong>PERFORMANCE</strong>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6 mini-5">
                  <div className="login-form">
                    <h5>Forgot Password</h5>
                    {Error && (
                      <p style={{ color: "red", fontSize: "14px" }}>
                        {Error.error}
                      </p>
                    )}
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          id="email"
                          placeholder="Email"
                          name="email"
                          autoComplete="off"
                          {...register("email", {
                            required: "Email is Required",
                            pattern: {
                              value:
                                /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
                              message: "Email is not Valid",
                            },
                          })}
                        />
                      </div>
                      <p style={{ color: "red", fontSize: "14px" }}>
                        {errors.email?.message}
                      </p>
                      <div className="login-linkedin">
                        <button type="submit" className="btn btn-secondary">
                          Submit
                        </button>
                        &nbsp;
                        <h5>Steps :</h5>
                        <li>Enter your mail id to reset password. </li>
                        <li>You will recive a mail to regenerate password.</li>
                        <li>
                          Once your password has been reset you are good to
                          LOGIN{" "}
                        </li>
                      </div>
                    </form>
                    <h5>SIGN IN FOR AN ACCOUNT</h5>
                    <Link to="/login" className="btn btn-signup">
                      Sign in
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="img-list">
            <div className="container-fluid">
              <div className="row">
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img2.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img3.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img4.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img5.png"
                      alt="neet"
                    />
                  </figure>
                </div>
                <div className="col">
                  <figure>
                    <img
                      className="img-fluid w-100"
                      src="/assets/images/img6.png"
                      alt="neet"
                    />
                  </figure>
                </div>
              </div>
            </div>
          </section>
        </main>
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => {
  const signUpError = state.authentication.forgetPassword;
  const is_user = state.user.is_user;

  return {
    signUpError: signUpError,
    is_user: is_user,
  };
};

const mapDispatchToProps = (dispatch, state) => {
  return {
    forgePassword: (data, navigate) =>
      dispatch(forgetPasswordAction(data, navigate)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgetPassword);
